/** @format */

// import { findTreeDataByAll, findTreeDataByTheOrg, findTreeDataByOrg } from '@/api/platform/org/org'
import { orgFindTreeDataByAll as findTreeDataByAll } from '@/api/position/index';
import { ActionUtils } from '@/utils/action';
import { $utils } from '@/utils/publicUtils';

export default {
	methods: {
		initTreeTypeEven(type, params, methods, invokingType, extraOptions) {
			return new Promise((resolve, reject) => {
				switch (type) {
					case '1':
						methods
							.findTreeDataByAll({ params, invokingType, type })
							.then((data) => {
								resolve(data);
							})
							.catch(() => {
								reject([]);
							});
						break;
					case '2':
						methods
							.findTreeDataByTheOrg({ params, invokingType, type, extraOptions })
							.then((data) => {
								resolve(data);
							})
							.catch(() => {
								reject([]);
							});
						break;
					case '3':
						methods
							.findTreeDataByOrg({ params, invokingType, type, extraOptions })
							.then((data) => {
								resolve(data);
							})
							.catch(() => {
								reject([]);
							});
						break;
					case '5':
						methods
							.findTreeDataByTheOrgFive({ params, invokingType, type, extraOptions })
							.then((data) => {
								resolve(data);
							})
							.catch(() => {
								reject([]);
							});
						break;
				}
			});
		},
		// 查询全部-1
		findTreeDataByAll(paramsOptions) {
			let params = paramsOptions.invokingType !== 'node' ? paramsOptions.params : {};
			if (paramsOptions.invokingType === 'node') {
				params = this.conformityParams(paramsOptions);
			}
			return new Promise((resolve, reject) => {
				findTreeDataByAll(ActionUtils.formatParams(params))
					.then((res) => {
						resolve(res);
					})
					.catch(() => {
						reject([]);
					});
			});
		},

		// 查询当前-2
		// findTreeDataByTheOrg(paramsOptions) {
		// 	let params = paramsOptions.invokingType !== 'node' ? paramsOptions.params : {};
		// 	if (paramsOptions.invokingType === 'node') {
		// 		params = this.conformityParams(paramsOptions);
		// 	}
		// 	return new Promise((resolve, reject) => {
		// 		findTreeDataByTheOrg(params)
		// 			.then((res) => {
		// 				resolve(res.data);
		// 			})
		// 			.catch(() => {
		// 				reject([]);
		// 			});
		// 	});
		// },

		// 查询指定-3
		// findTreeDataByOrg(paramsOptions) {
		// 	const params = paramsOptions.params;
		// 	return new Promise((resolve, reject) => {
		// 		findTreeDataByOrg(params)
		// 			.then((res) => {
		// 				resolve(res.data);
		// 			})
		// 			.catch(() => {
		// 				reject([]);
		// 			});
		// 	});
		// },

		// 上下级专用-5
		// findTreeDataByTheOrgFive(paramsOptions) {
		// 	let params = paramsOptions.invokingType !== 'node' ? paramsOptions.params : {};
		// 	if (paramsOptions.invokingType === 'node') {
		// 		params = this.conformityParams(paramsOptions);
		// 	}
		// 	return new Promise((resolve, reject) => {
		// 		findTreeDataByTheOrg(params)
		// 			.then((res) => {
		// 				resolve(res.data);
		// 			})
		// 			.catch(() => {
		// 				reject([]);
		// 			});
		// 	});
		// },

		// 整合相同参数
		conformityParams(paramsOptions) {
			const params = {};
			const node = paramsOptions.params;
			const check =
				$utils.isNotEmpty(this.currentOrgIdValue) &&
				node.data.id === '0' &&
				this.$store.getters.userId !== this.externalUseId &&
				this.$store.getters.isSuper;
			switch (paramsOptions.type) {
				case '1':
				case '2':
					params.orgId = node.level === 0 ? null : check ? this.currentOrgIdValue : node.data.id;
					paramsOptions.extraOptions ? (params.includeSub = paramsOptions.extraOptions.includeSub) : null;
					break;
				case '5':
					params.orgId =
						node.level === 0
							? $utils.isNotEmpty(paramsOptions.extraOptions) && paramsOptions.extraOptions.externalGrounpId !== ''
								? paramsOptions.extraOptions.externalGrounpId
								: null
							: $utils.isNotEmpty(paramsOptions.extraOptions) && paramsOptions.extraOptions.userid !== '1'
							? paramsOptions.extraOptions.externalGrounpId
							: node.data.id;
					params.includeSub = true;
					break;
			}
			return params;
		},
	},
};
